import logo from "./logo.svg";
import "./App.css";
import { Routes, Route , Link , useRoutes } from "react-router-dom";
import routes from './routes'
import {MathJaxContext , MathJax} from 'better-react-mathjax'
import Header from "./Components/Header/Header";




function App() {

  const router = useRoutes(routes)

  return (
    <MathJaxContext>
     
      {router}
    </MathJaxContext>
  );
}

export default App;
